"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_widget_buttons_html_1 = __importDefault(require("./add-widget-buttons.html"));
require("./add-widget-buttons.less");
(function (module) {
    'use strict';
    function AddWidgetButtonsController(widgetMenu) {
        var $ctrl = this;
        var widgets = {
            primary: widgetMenu.getBasicItems(),
            secondary: widgetMenu.getChartItems().concat({ divider: true }, widgetMenu.getTableItems(), { divider: true }, widgetMenu.getOtherItems())
        };
        angular.extend($ctrl, {
            widgets: widgets,
            addWidget: function (type) {
                $ctrl.bdyCtrl.addWidgetToActivePage(type);
            }
        });
    }
    AddWidgetButtonsController.$inject = ['prWidgetMenuService'];
    module.component('prAddWidgetButtons', {
        controller: AddWidgetButtonsController,
        templateUrl: add_widget_buttons_html_1.default,
        require: {
            bdyCtrl: '^prBody'
        }
    });
}(angular.module('qualtrics.pr')));
